import * as React from 'react';
import { connect } from 'react-redux';
import { select } from '@rematch/select';

import { AppLayout } from '../../layouts/AppLayout';
import { Card } from 'ui';
import { ContentObjectRenderer } from '../../atoms/feed-object';
import { Loader } from '../../atoms/loader';
import { getFeedKey } from '../../models/feed';
import EditActivity from '../../../features/programs/feed/EditActivity';
import { onErrorReport, onSuccessReport } from '../../utils/report';

export class Renderer extends React.Component {
  state = {
    draft: undefined,
  };

  componentDidMount() {
    this.props.loadContentObject();
  }

  componentDidUpdate(preProps) {
    if (preProps.match.params.postId !== this.props.match.params.postId) {
      this.props.loadContentObject();
    }
  }

  initiatePostEditing = async (object) => {
    this.setState({ draft: object });
  };

  actions = {
    createComment: this.props.createComment,
    createObject: this.props.createObject,
    deleteObject: this.props.deleteObject,
    likeObject: this.props.likeObject,
    loadCollection: this.props.loadCollection,
    reportObject: this.props.reportObject,
    sortChange: this.props.sortChange,
    updateObject: this.props.updateObject,
    votePoll: this.props.votePoll,
    reloadObject: this.props.reloadContentObject,
    bookmarkObject: this.props.bookmarkObject,
  };

  render() {
    return (
      <AppLayout
        center={
          <React.Fragment>
            {this.props.loadingContentObject ? (
              <Loader />
            ) : this.props.contentObject ? (
              <Card shrinked>
                <ContentObjectRenderer
                  item={this.props.contentObject}
                  scrollToCommentId={this.props.match?.params.commentId}
                  scrollToReplyId={this.props.match?.params.replyId}
                  onCreateComment={this.actions.createComment}
                  onCreateObject={this.actions.createObject}
                  onDeleteObject={this.actions.deleteObject}
                  onEditObject={this.actions.updateObject}
                  onInitiatePostEditing={this.initiatePostEditing}
                  onLikeObject={this.actions.likeObject}
                  onReportObject={this.actions.reportObject}
                  onSortChange={this.actions.sortChange}
                  onVotePoll={this.actions.votePoll}
                  viewer={this.props.viewer}
                  onReloadObject={this.actions.reloadObject}
                  onBookmarkObject={this.actions.bookmarkObject}
                  commentsOpened
                />

                <EditActivity
                  poll={this.state.draft?.activity}
                  isOpened={this.state.draft && this.state.draft.type === 'activity'}
                  onCancel={() => this.setState({ draft: undefined })}
                  onSuccess={async () => {
                    await this.props.reloadContentObject(this.state.draft);
                    this.setState({ draft: undefined });
                  }}
                />
              </Card>
            ) : null}
          </React.Fragment>
        }
        right={<div />}
      />
    );
  }
}

const mapState = (state) => {
  return {
    contentObject: select.feed.findById(state, state.feed.currentObjectId),
    loadingContentObject: state.loading.effects.feed.findActivityAsync,
    viewer: select.session.user(state),
  };
};

const mapDispatch = (dispatch, props) => {
  const feedName = getFeedKey(props);
  return {
    loadContentObject: () => {
      return dispatch.feed.findActivityAsync({
        feed: feedName,
        postId: props.match.params.postId,
      });
    },
    createComment: (draft, parent_id) => {
      return dispatch.feed.createAsync({ draft: draft, parent_id: parent_id, comment: true });
    },
    createObject: (draft) => {
      return dispatch.feed.createAsync({ draft: draft, parent_id: null });
    },
    updateObject: async (object) => {
      return dispatch.feed.updateAsync({ object: object });
    },
    likeObject: (object) => {
      return dispatch.feed.likeAsync({ object: object });
    },
    deleteObject: async ({ object, originalItem }) => {
      if (await window.confirm('Delete this Post/Event/Comment?')) {
        return dispatch.feed.deleteAsync({ object, originalItem });
      }
    },
    reportObject: async (object) => {
      if (await window.confirm('Report this Post/Event/Comment?')) {
        return dispatch.feed.reportAsync({ object: object, onSuccess: onSuccessReport, onError: onErrorReport });
      }
    },
    votePoll: ({ choiceId }) => {
      return dispatch.feed.votePollAsync({ choiceId });
    },
    reloadContentObject: (object) => {
      dispatch.feed.reloadAsync({ feed: feedName, postId: object.id });
    },
    bookmarkObject: (object) => {
      return dispatch.feed.bookmarkAsync({ object: object });
    },
  };
};

export const PageActivity = connect(mapState, mapDispatch)(Renderer);
